module.exports = __webpack_public_path__ + "static/media/index_02.e04b118d.png";